import {
  useWSModal,
  WSActions,
  WSAlert,
  WSElement,
  WSFlexBox,
  WSPanel
} from "@wingspanhq/fe-component-library";
import {
  IPayeeEngagementResponse,
  IPayeeResponse
} from "@wingspanhq/payments/dist/interfaces";
import { FieldView } from "../../../shared/components/FieldView/FieldView";
import React from "react";
import { wsName } from "@wingspanhq/utils/dist/name/wsName";

export interface DeletionNotAllowedModalProps {
  payee: IPayeeResponse;
  engagement: IPayeeEngagementResponse;
  onClose: () => void;
}

export const DeletionNotAllowedModal: React.FC<
  DeletionNotAllowedModalProps
> = ({ payee, engagement, onClose }) => {
  const payeeNames = wsName({
    user: payee.user!,
    member: payee.member
  });

  return (
    <>
      <WSPanel>
        <WSFlexBox gap="XL">
          <FieldView
            label="Engagement name"
            value={engagement.engagementName}
          />
          <FieldView
            label="Contractor name"
            value={payeeNames.getResolvedName()}
          />
        </WSFlexBox>
      </WSPanel>

      <WSAlert
        my="2XL"
        theme="warning"
        icon="alert"
        size="M"
        title="Contractor engagement cannot be deleted when:"
      >
        <WSElement as="ul" ml="L">
          <li>Active invoices exist.</li>
          <li>Historical payment data (e.g. invoices) exists</li>
        </WSElement>
        If this contractor engagement is no longer used, it can be archived
        instead.
      </WSAlert>

      <WSActions
        alignment="fill"
        buttons={[
          {
            label: "Done",
            onClick: onClose,
            kind: "Secondary"
          }
        ]}
      />
    </>
  );
};

export const useDeletionNotAllowedModal = () => {
  return useWSModal(DeletionNotAllowedModal, {
    title: "Delete contractor engagement",
    size: "M"
  });
};
